import React from 'react';

import { Icon } from '@components';

interface MultipleLeadSelectionBottomBarProps {
  selectedCount: number;
  onClearSelection: () => void;
  onTagsAction: () => void;
  onAssigneesAction: () => void;
  onStatusAction: () => void;
  onLeadsAction: () => void;
  selectedSection?: 'tags' | 'assignees' | 'status' | 'leads';
}

const MultipleLeadSelectionBottomBar: React.FC<
  MultipleLeadSelectionBottomBarProps
> = ({
  selectedCount,
  onClearSelection,
  onTagsAction,
  onAssigneesAction,
  onStatusAction,
  onLeadsAction,
  selectedSection
}) => (
  <div className="fixed inset-x-0 bottom-24 z-50 flex h-12.5 items-center justify-center px-2">
    <div className="flex items-center gap-2.5 rounded-xl bg-content p-2 shadow-[0px_4px_9px_0px_rgba(0,0,0,0.1)]">
      <div className="flex items-center gap-2 px-2.5">
        <button
          type="button"
          className={`flex items-center gap-1.5 rounded-lg bg-content p-2 ${
            selectedSection === 'leads'
              ? 'border border-darkGrey'
              : 'border border-transparent'
          }`}
          onClick={onLeadsAction}
          aria-label="Select leads"
        >
          <Icon name="users" size="16" />
          <div className="text-xs font-medium text-grey40">
            {selectedCount} leads selected
          </div>
          <button
            type="button"
            onClick={onClearSelection}
            className="flex size-4 items-center justify-center"
          >
            <Icon name="close" size="12" stroke="#595959" />
          </button>
        </button>
      </div>

      <div className="flex items-center gap-2 px-2.5">
        <button
          type="button"
          onClick={onTagsAction}
          className={`flex h-8.5 w-[119px] items-center gap-1.5 rounded-md bg-content p-2 ${
            selectedSection === 'tags'
              ? 'border border-darkGrey'
              : 'border border-transparent'
          }`}
        >
          <Icon name="tag" size="16" />
          <span className="text-xs font-medium text-grey40">Tags</span>
        </button>
      </div>

      <div className="flex items-center gap-2 px-2.5">
        <button
          type="button"
          onClick={onAssigneesAction}
          className={`flex h-8.5 w-30 items-center gap-1.5 rounded-md bg-content p-2 ${
            selectedSection === 'assignees'
              ? 'border border-darkGrey'
              : 'border border-transparent'
          }`}
        >
          <Icon name="assignee-avatar" size="16" />
          <span className="text-xs font-medium text-grey40">Assignees</span>
        </button>
      </div>

      <div className="flex items-center gap-2 px-2.5">
        <button
          type="button"
          onClick={onStatusAction}
          className={`flex h-8.5 w-30 items-center gap-1.5 rounded-md bg-content p-2 ${
            selectedSection === 'status'
              ? 'border border-darkGrey'
              : 'border border-transparent'
          }`}
        >
          <Icon name="status-loader" size="16" />
          <span className="text-xs font-medium text-grey40">Status</span>
        </button>
      </div>
    </div>
  </div>
);

export default MultipleLeadSelectionBottomBar;
